"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopPropagationView = void 0;
var react_1 = __importDefault(require("react"));
var View_1 = require("@amzn/atoz-web/View");
var StopPropagationView = function (_a) {
    var children = _a.children;
    var handleClick = function (e) {
        e.stopPropagation();
    };
    return (react_1.default.createElement(View_1.View, { className: "stop-propagation-div", "data-testid": "stop-propagation-div", onClick: handleClick }, children));
};
exports.StopPropagationView = StopPropagationView;
